import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export default function useUpdateVisibility(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  return useMutation(
    async ({
      gameId,
      visibility,
    }: {
      gameId: string;
      visibility: 'public' | 'private';
    }) => {
      const response = await ChessRestClient.post(
        `learning/study_games/${gameId}/visibility/`,
        {visibility},
      );
      return response.data;
    },
    {
      onSuccess: data => {
        handleOnSuccess?.(data);
      },
      onError: error => {
        handleOnError?.(error);
      },
    },
  );
}
